/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Start_Blank_DescInputs */

const en_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your resume from an empty template with guided sections`)
};

const de_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle deinen Lebenslauf aus einer leeren Vorlage mit geführten Abschnitten`)
};

const fr_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crée ton CV à partir d'un modèle vide avec des sections guidées`)
};

const es_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree su currículum desde una plantilla vacía con secciones guiadas`)
};

const it_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruisci il tuo curriculum da un modello vuoto con sezioni guidate`)
};

const nl_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bouw je CV op vanuit een leeg sjabloon met begeleide secties`)
};

const pl_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbuduj CV z pustego szablonu z prowadzonymi sekcjami`)
};

const fi_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakenna ansioluettelosi tyhjästä mallista ohjatuilla osioilla`)
};

const da_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byg dit CV fra en tom skabelon med guidede sektioner`)
};

const sv_resumes_start_blank_desc = /** @type {(inputs: Resumes_Start_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygg ditt CV från en tom mall med guidade sektioner`)
};

/**
* | output |
* | --- |
* | "Build your resume from an empty template with guided sections" |
*
* @param {Resumes_Start_Blank_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_start_blank_desc = /** @type {((inputs?: Resumes_Start_Blank_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Start_Blank_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_start_blank_desc(inputs)
	if (locale === "fr") return fr_resumes_start_blank_desc(inputs)
	if (locale === "es") return es_resumes_start_blank_desc(inputs)
	if (locale === "it") return it_resumes_start_blank_desc(inputs)
	if (locale === "nl") return nl_resumes_start_blank_desc(inputs)
	if (locale === "pl") return pl_resumes_start_blank_desc(inputs)
	if (locale === "fi") return fi_resumes_start_blank_desc(inputs)
	if (locale === "da") return da_resumes_start_blank_desc(inputs)
	if (locale === "sv") return sv_resumes_start_blank_desc(inputs)
	return en_resumes_start_blank_desc(inputs)
});